export default __webpack_public_path__ + "static/media/grass.54f8c765.png";